<ng-container *ngIf="slider.highlight">
	<kwo-highlighted-video-slider [slider]="slider"></kwo-highlighted-video-slider>
</ng-container>

<ng-container *ngIf="!slider.highlight">
	<section class="video-slider">
		<div class="slider-title" [innerHTML]="slider.title"></div>

		<ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
			<div ngxSlickItem *ngFor="let item of slider.items" class="slide">
				<kwo-video-item [video]="item" [mode]="slider.mode"></kwo-video-item>
			</div>
		</ngx-slick-carousel>
	</section>
</ng-container>